import React, { memo } from 'react'
import { useStyles } from './styles'
import { GenealogyCard } from '../GenealogyCard'
import { concatStyles } from 'src/utils'
import { montaTypes } from 'src/constants/montaType'
import { useGenealogicalDiagram } from './hooks/useGenealogicalDiagram'
import { IAnimal } from 'src/dto/animal.dto'

interface GenealogicalDiagramProps {
  dataAnimal: IAnimal
}

const GenealogicalDiagramComponent = ({ dataAnimal }: GenealogicalDiagramProps) => {
  const {
    genealogyData,
    hierarchyDiagramState,
    zoom,
    position,
    isMobile,
    setPosition,
    setZoom,
    handleZoomParents,
    setHierarchyDiagramState,
    handleWheel,
    handleMouseMove,
    handleMouseUp,
    handleMouseDown,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  } = useGenealogicalDiagram(dataAnimal)

  const styles = useStyles()

  return !genealogyData?.parents?.father || !genealogyData?.parents?.mother ? (
    <div className={styles.noParentsContent}>
      <span>Animal sem informações genealógicas disponíveis.</span>
    </div>
  ) : (
    <div
      id='hierarchyDiagram'
      className={styles.zoomContainer}
      onWheel={handleWheel}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={styles.zoomContent}
        style={{
          transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`
        }}
      >
        <div className={styles.genealogicalDiagramContent}>
          {/* <GenealogyCard data={{ sexo: 'F' }} /> */}
          <div className={styles.genealogicalDiagramHieraqyContainer}>
            {/* Hierarquia dos Avós */}
            {hierarchyDiagramState.paternalGrandparentsIsExpanded && (
              <div className={styles.genealogicalDiagramHieraqyPaternalGrandparentsComponents}>
                <div className={styles.genealogicalDiagramMaternalGrandparentsComponents}>
                  <GenealogyCard
                    familyMember={'Avô'}
                    cowSonName={genealogyData?.self.nome || '-'}
                    className={styles.genealogicalDiagramCard}
                    data={genealogyData?.paternalGrandparents?.paternalGrandfather}
                  />
                  <span className={styles.genealogicalDiagramGrauFamilly}>Avós</span>
                  <span className={styles.genealogicalDiagramGrauMontaType}>
                    {genealogyData?.parents?.father?.tipoMonta
                      ? montaTypes[genealogyData?.parents?.father?.tipoMonta].value || 'Monta não definida'
                      : 'Monta não definida'}
                  </span>
                  <GenealogyCard
                    familyMember={'Avó'}
                    cowSonName={genealogyData?.self.nome || '-'}
                    className={styles.genealogicalDiagramCard}
                    data={genealogyData?.paternalGrandparents?.paternalGrandmother}
                  />
                </div>
              </div>
            )}
            {/* Hierarquia dos Avós */}

            {hierarchyDiagramState.maternalGrandparentsExpanded && (
              <div className={styles.genealogicalDiagramHieraqyMaternalGrandparentsComponents}>
                <div className={styles.genealogicalDiagramComponents}>
                  <GenealogyCard
                    familyMember={'Avô'}
                    cowSonName={genealogyData?.self.nome || '-'}
                    className={styles.genealogicalDiagramCard}
                    data={genealogyData?.maternalGrandparents?.maternalGrandfather}
                  />
                  <span className={styles.genealogicalDiagramGrauFamilly}>Avós</span>
                  <span
                    className={concatStyles(
                      styles.genealogicalDiagramGrauMontaType,
                      styles.genealogicalDiagramGrauMontaTypeMobile
                    )}
                  >
                    {genealogyData?.parents?.mother?.tipoMonta
                      ? montaTypes[genealogyData?.parents?.mother?.tipoMonta].value || 'Monta não definida'
                      : 'Monta não definida'}
                  </span>
                  <GenealogyCard
                    familyMember={'Avó'}
                    cowSonName={genealogyData?.self.nome || '-'}
                    className={styles.genealogicalDiagramCard}
                    data={genealogyData?.maternalGrandparents?.maternalGrandmother}
                  />
                </div>
              </div>
            )}

            <div className={styles.genealogicalDiagramHieraqyComponents}>
              <div
                className={`${styles.genealogicalDiagramComponents} ${styles.genealogicalDiagramComponentsWithParents}`}
              >
                <GenealogyCard
                  familyMember={'Pai'}
                  cowSonName={genealogyData?.self.nome || '-'}
                  className={styles.genealogicalDiagramCard}
                  data={genealogyData?.parents?.father}
                  hasParentHierarchy={
                    !!genealogyData?.paternalGrandparents?.paternalGrandfather &&
                    !!genealogyData?.paternalGrandparents?.paternalGrandmother
                  }
                  handlerOpenParentHierarchy={() => {
                    if (hierarchyDiagramState.maternalGrandparentsExpanded) {
                      handleZoomParents()
                    } else {
                      const paternalGrandparentsPostion = isMobile ? { x: 0, y: 150 } : { x: 152, y: 459 }
                      setPosition(paternalGrandparentsPostion)
                      setZoom(isMobile ? 0.8 : 0.75)
                    }
                    setHierarchyDiagramState((prevState) => ({
                      ...prevState,
                      paternalGrandparentsIsExpanded: true
                    }))
                  }}
                />
                <span className={styles.genealogicalDiagramGrauFamilly}>Pais</span>
                <span className={styles.genealogicalDiagramGrauMontaType}>
                  {genealogyData?.self?.tipoMonta
                    ? montaTypes[genealogyData?.self?.tipoMonta].value || 'Monta não definida'
                    : 'Monta não definida'}
                </span>
                <GenealogyCard
                  familyMember={'Mãe'}
                  cowSonName={genealogyData?.self.nome || '-'}
                  className={styles.genealogicalDiagramCard}
                  data={genealogyData?.parents?.mother}
                  hasParentHierarchy={!!genealogyData?.maternalGrandparents}
                  handlerOpenParentHierarchy={() => {
                    if (hierarchyDiagramState.paternalGrandparentsIsExpanded) {
                      handleZoomParents()
                    } else {
                      const maternalGrandparentsPostion = isMobile ? { x: 0, y: 150 } : { x: -81, y: 463 }
                      setPosition(maternalGrandparentsPostion)
                      setZoom(isMobile ? 0.8 : 0.8)
                    }

                    setHierarchyDiagramState((prevState) => ({
                      ...prevState,
                      maternalGrandparentsExpanded: true
                    }))
                  }}
                />
              </div>
            </div>
            <GenealogyCard className={styles.genealogicalDiagramMainCard} data={genealogyData?.self} />
          </div>
        </div>
      </div>
    </div>
  )
}

export const GenealogicalDiagram = memo(GenealogicalDiagramComponent)
